<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row" style="margin-top:10px">
      <div class="col-12 mb-4">
        <v-btn @click="$router.go(-1)" small outlined style="border: none;margin-right: 10px;background:#fff" v-b-tooltip.hover title="Retour"><v-icon small>mdi mdi-arrow-left</v-icon> Retour </v-btn>
          <div class="mt-3">
            <v-alert type="info">
              {{ $t('reversements.config_description') }}
            </v-alert>
          </div>
            <v-card>
                <v-card-title style="padding: 0">
                   <div class="col-md-8 col-lg-8 col-12 pb-0 pl-0">
                          <v-btn small   style="background: orange;color: #fff;"
                                   @click="setdefault" class="btn-custom-add mb-2" >
                                  
                        <span v-if="marchandInfo!==undefined  && marchandInfo._settingreversement!=null && marchandInfo._settingreversement._usermeanspaiement!=null">
                          <span v-if="marchandInfo && marchandInfo._settingreversement==null && marchandInfo._settingreversement._usermeanspaiement==null" > {{$t('reversements.new')}} </span>
                          <span v-else> {{$t('reversements.newchange')}} </span>
                        </span>
                            <span v-else>
                                <span > {{$t('reversements.new')}} </span>
                            </span>
                        </v-btn>
                    </div>
                    <div class="container" v-if="marchandInfo!=null && marchandInfo._settingreversement !=null && marchandInfo._settingreversement._usermeanspaiement!=null && marchandInfo._settingreversement._usermeanspaiement._means_paiement!=null">
                        <v-alert
                                v-if="!marchandInfo._settingreversement._usermeanspaiement._means_paiement._active"
                                border="right"
                                colored-border
                                type="warning"
                                elevation="2"
                        >
                            {{ $t("usermeans.meansinfo2") }}, {{ $t("usermeans.meansinfosuite2") }}
                        </v-alert>

                    </div>
                </v-card-title>

            <div class="row" v-if="marchandInfo">
              <div class="col-5" style="background: #fff">
              <h6 style="font-weight:200;">{{$t("reversements.detail")}}</h6>
                <v-text-field v-if="marchandInfo===undefined" color="primary" loading
                              disabled></v-text-field>
                <v-row  v-if="marchandInfo!==undefined">
                  <v-col cols="12" v-if="marchandInfo._settingreversement!=null && marchandInfo._settingreversement._usermeanspaiement!=null">
                    <table class=" table table-striped">
                      <tbody>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px"> {{$t("reversements.source_reception")}} :</td>
                        <td>
                          <img width="40" height="40"
                              style="border-radius: 50%;
                                                                        border: 1px solid #82D0C9; margin-right: 1%"
                              v-lazy="'/'+marchandInfo._settingreversement._usermeanspaiement._means_paiement._file.substr(7)" alt="">

                          {{marchandInfo._settingreversement._usermeanspaiement._means_paiement._name}}
                          ({{marchandInfo._settingreversement._usermeanspaiement._means_paiement._country._name}})
                        </td>
                      </tr>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px"> {{$t("reversements.type_source")}} :	</td>
                        <td class="text-capitalize">

                          {{marchandInfo._settingreversement._usermeanspaiement._account_number+' ('+marchandInfo._settingreversement._usermeanspaiement._type+')'}}
                        </td>
                      </tr>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px"> {{$t("reversements.account")}} :	</td>
                        <td class="text-capitalize">
                          {{marchandInfo._settingreversement._usermeanspaiement._account_name}}
                          {{marchandInfo._settingreversement._usermeanspaiement._account_surname}}
                        </td>
                      </tr>
                      <tr style="padding: 15px" v-if="marchandInfo._settingreversement._type_transfert!='byperiode'" >
                        <td style="padding: 15px"> {{$t("reversements.montant3")}} ({{marchandInfo.wallet.devise._code_alpha}}) :</td>
                        <td>{{marchandInfo._settingreversement._montant}}</td>
                      </tr>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px">{{$t("reversements.periode")}} :</td>
                        <td>  <span v-if="marchandInfo._settingreversement._type_transfert=='byperiode'">
                                                                          {{$t("reversements.byperiode")}} ({{marchandInfo._settingreversement._periode}}) </span>
                          <span v-else>{{$t("reversements.bystep")}}</span>
                        </td>
                      </tr>


                      <tr style="padding: 15px" >
                        <td style="padding: 15px">{{$t("reversements.send_mail")}}:</td>
                        <td>
                                                                        <span v-if="marchandInfo._settingreversement._send_mail=='refused'">
                                                                            {{$t("reversements.emailGetNot")}}</span>
                          <span v-else>{{$t("reversements.emailGet")}}</span>
                        </td>
                      </tr>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px">{{$t("reversements.date")}} :</td>
                        <td>{{getDate(marchandInfo._settingreversement._created_at)}}</td>
                      </tr>
                      <tr style="padding: 15px" >
                        <td style="padding: 15px">{{$t("reversements.last_date")}} :</td>
                        <td>{{(marchandInfo._settingreversement._last_reversement_date)?getDate(marchandInfo._settingreversement._last_reversement_date):'---'}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
            </div>
            <div class="col-7">
              <h6 style="font-weight:200;">{{$t("reversements.historique_configs")}}</h6>
               <div class="col-12 col-lg-5 p-0 mb-4 ">
                    <v-text-field v-model="search" solo append-icon="mdi-magnify" style="text-transform:normal!important" label="Search" single-line hide-details ></v-text-field>
                    </div>
              <v-data-table v-if="marchandInfo!==undefined" :headers="headers" :items="historiqueReversementsConfigs" :search="search" sort-by="name" class="elevation-0 mt-0 pt-0" :loading="historiqueReversementsConfigs===undefined" loading-text="Chargement en cours...">
                <template v-slot:item._send_mail="{ item }">
                  <span v-if="item._send_mail=='success'">Oui</span>
                  <span v-else>Non</span>
                </template>
                <template v-slot:item._usermeanspaiement._means_paiement="{ item }"  >
                  <span  v-if="item._usermeanspaiement && item._usermeanspaiement._means_paiement " style="cursor: pointer;color: #28B3A6">
                          {{item._usermeanspaiement._means_paiement._name}}
                          ({{item._usermeanspaiement._means_paiement._country._name}}) :
                          {{item._usermeanspaiement._account_name}}
                          {{item._usermeanspaiement._account_surname}}
                         </span>
                    <span v-else>---</span>

                </template>
                <template v-slot:top>
                  <v-toolbar flat style="min-height: 0!important;">
                    <v-dialog v-model="dialog" max-width="800px">
                      <v-card>
                        <v-card-title >
                          <v-col md="11" lg="11" sm="11">
                            <span class="headline">  {{ formTitle }} </span>
                          </v-col>
                          <v-col md="1" lg="1" sm="1">
                            <v-icon style="cursor: pointer" @click="setdefaultClose()" > mdi-close  </v-icon>
                          </v-col>
                        </v-card-title>
                        <v-card-text>
                          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                            <v-stepper v-model="e1">
                              <v-stepper-header>
                                <v-stepper-step :complete="e1 > 1" step="1">{{$t('reversements.etape1')}}
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 2" step="2">{{$t('reversements.etape2')}}
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="3">{{$t('reversements.etape3')}}
                                </v-stepper-step>
                              </v-stepper-header>

                              <v-stepper-items>
                                <v-stepper-content step="1">
                                  <div class="row">
                                    <div class="col-12 col-md-6 col-lg-6"
                                         style="text-align: center">
                                      <v-card
                                          @click="chooseItem('Mobile')"
                                          id="Mobile"
                                          class="ma-3 pa-6 chooseAll"
                                          outlined
                                          tile
                                          :style="getBackColor('Mobile')+'text-align: center;'"
                                      >
                                        <img v-lazy="'/images/phonemode.svg'"
                                             width="120" alt=""
                                             style="padding: 2.5%">
                                        <h3 style="margin-top: 5%; font-weight: bold;"
                                            class="text-uppercase">
                                          {{$t('means_paiement.moyenmobile')}}</h3>

                                      </v-card>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6"
                                         style="text-align: center">
                                      <v-card
                                          @click="chooseItem('Banque')"
                                          id="Banque"
                                          class="ma-3 pa-6 chooseAll"
                                          outlined
                                          tile
                                          :style="getBackColor('Banque')+'text-align: center;'"
                                      >
                                        <img v-lazy="'/images/bankmode2.png'"
                                             width="120" alt="">
                                        <h3 style="margin-top: 5%; font-weight: bold"
                                            class="text-uppercase">
                                          {{$t('means_paiement.moyenbancaire')}}</h3>

                                      </v-card>
                                    </div>
                                  </div>
                                  <div class="text-right container">
                                    <v-btn
                                        color="primary"
                                        @click="e1 = 2"
                                        :disabled="!step1"
                                    >
                                      {{$t('continuer')}}
                                    </v-btn>
                                  </div>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                  <div class="row">
                                    <div class="col-12 col-md-6 col-lg-6"
                                         style="text-align: center">
                                      <v-card
                                          @click="chooseItemRev('bystep')"
                                          id="bystep"
                                          class="ma-3 pa-6 chooseAllRev"
                                          outlined
                                          tile
                                          :style="getBackColorRev('bystep')+'text-align: center;'"
                                      >
                                        <img v-lazy="'/images/step.png'"
                                             width="120" alt=""
                                             style="padding: 2.5%">
                                        <h3 style="margin-top: 5%; font-weight: bold;"
                                            class="text-uppercase">
                                          {{$t('reversements.bystep')}}</h3>

                                      </v-card>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6"
                                         style="text-align: center">
                                      <v-card
                                          @click="chooseItemRev('byperiode')"
                                          id="byperiode"
                                          class="ma-3 pa-6 chooseAllRev"
                                          outlined
                                          tile
                                          :style="getBackColorRev('byperiode')+'text-align: center;'"
                                      >
                                        <img v-lazy="'/images/periode.png'"
                                             width="105" alt="">
                                        <h3 style="margin-top: 5%; font-weight: bold"
                                            class="text-uppercase">
                                          {{$t('reversements.byperiod')}}</h3>
                                      </v-card>
                                    </div>
                                  </div>
                                  <div class="text-right container">
                                    <div class="offset-md-7 col-md-5" >
                                      <div class="row">
                                        <div   class="col-md-6" style="padding: 2px">
                                          <v-btn
                                              class=" dark"
                                              text @click="e1 = 1">{{$t('return')}}</v-btn>

                                        </div>
                                        <div   class="col-md-6" style="padding: 2px">
                                          <v-btn
                                              color="primary"
                                              @click="e1 = 3"
                                              :disabled="!step2"
                                          >
                                            {{$t('continuer')}}
                                          </v-btn>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-stepper-content>
                                <v-stepper-content step="3">
                                  <v-alert v-if="errors" dense outlined
                                           :type="(errors.update_error)?'error':'success'">
                                    {{$t(errors.operation)}}
                                  </v-alert>
                                  <v-text-field v-if="submitting" color="primary" loading
                                                disabled></v-text-field>
                                  <v-row>
                                    <v-col v-if="editedItem._type_transfert=='byperiode'" cols="12" sm="6"
                                           md="12">
                                      <v-select
                                          @change="validestep(3)"
                                          :rules="periodeRules"
                                          v-model="editedItem._periode"
                                          :items="itemSteps"
                                          label="Période de reversement"
                                          placeholder="Période de reversement"
                                      ></v-select>
                                    </v-col>
                                    <v-col v-if="editedItem._type_transfert=='bystep'" cols="12" sm="6"
                                           md="12">
                                      <v-text-field @keyup="validestep(3)"
                                                    type="number" :min="(generals?generals.mminr:'0')" :rules="montantRules" v-model="editedItem._montant"
                                                    :label="$t('reversements.montant')+'( >= '+(generals?generals.mminr:'')+' '+''+(devise?devise._code_alpha:'')+')'">
                                        0
                                      </v-text-field>
                                      <span style="color: #B71C1C" v-if="errors_montant!=null">{{errors_montant}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                      <v-select
                                          :rules="usermeanspaiementRules"
                                          v-model="editedItem._usermeanspaiement"
                                          :items="user_means_paiements"
                                          item-text="_account_name"
                                          item-value="_id"
                                          label="Choisir un moyen"
                                          placeholder="Choisir un moyen "
                                          @change="validestep(3)">
                                        <template slot="selection" slot-scope="user_means_paiements">
                                          {{ user_means_paiements.item._account_name }}
                                          {{ user_means_paiements.item._account_surname }}
                                          - {{user_means_paiements.item._account_number }}
                                          ({{user_means_paiements.item._means_paiement._name }})
                                        </template>
                                        <template slot="item" slot-scope="user_means_paiements">
                                          {{ user_means_paiements.item._account_name }}
                                          {{ user_means_paiements.item._account_surname }}
                                          - {{
                                            user_means_paiements.item._account_number }} ({{
                                            user_means_paiements.item._means_paiement._name }})
                                        </template>
                                      </v-select>
                                      <span style="color: #B71C1C" v-if="errors_means!=null">{{errors_means}}</span>

                                      <v-btn text small color="primary">
                                        <router-link :to="{name:'usermeanspaiments'}">
                                          {{$t('reversements.add_means')}}
                                        </router-link>
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="12">
                                      <v-checkbox
                                          v-model="editedItem._send_mail"
                                          label="Recevoir un mail à chaque reversement"
                                          color="primary"
                                          value="success"
                                          hide-details
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                  <div class="text-right container">
                                    <div class="offset-md-7 col-md-5" >
                                      <div class="row">
                                        <div   class="col-md-6" style="padding: 2px">
                                          <v-btn
                                              class=" dark"
                                              text @click="e1 = 2">{{$t('return')}}</v-btn>
                                        </div>
                                        <div   class="col-md-6" style="padding: 2px">
                                          <v-btn
                                              color="primary"
                                              @click.prevent="save"
                                              :disabled="!step3">
                                            {{$t('save')}}
                                          </v-btn>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-stepper-content>
                              </v-stepper-items>
                            </v-stepper>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item._usermeanspaiement._means_paiement._type="{ item }">
                  <v-chip v-if="item._usermeanspaiement && item._usermeanspaiement._means_paiement " :color="getColor(item._usermeanspaiement._means_paiement._type)" dark>{{ item._usermeanspaiement._means_paiement._type }}</v-chip>
                    <span v-else>---</span>
                </template>

                <template v-slot:item._last_reversement_date="{ item }">
                  {{ (item._last_reversement_date)? getDate(item._last_reversement_date):'---'}}
                </template>
                <template v-slot:item._created_at="{ item }">
                  {{ getDate(item._created_at)}}
                </template>
                <template v-slot:no-data>
                  {{$t('no_data')}}
                </template>
              </v-data-table>
                <div v-else>
                    <div class="col-12 text-center alert alert-danger notification_box" style="margin-top: 15%">
                        {{$t('load_data_error')}}
                        <a style="text-decoration: underline;margin-left: 5px" href="mailto:equipe@intram.org">{{$t('contact_admin')}}</a>
                    </div>
                </div>
            </div>
            </div>
             
            </v-card>
        </div>
      <!-- dialog detail config actuel -->
     
      <customsnackbar
        :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor"
        :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../mixins/helpers";

    export default {

        label: "ReversementConfig",
          mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                customSnack:{
                      snackbar: false,
                      text: "",
                      snackcolor:"black",
                      snackbBtnColor:"white",
                      snacktimeout:2000
                    },
                valid: true,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                itemSteps: [
                    "Mois", "Trimestre", "Semestre"
                ],
                search: '',
                dialog: '',
                dialogDetail: false,
                 note:"",
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: '',
                generaldatas:{},
                devisedatas:{},
                e1: 1,
                typesLists:['Mobile', 'Banque'],
                typesLists2:['bystep', 'byperiode'],
              headers: [
                {
                  text: 'Source de réception',
                  align: 'start',
                  sortable: true,
                  value: '_usermeanspaiement._means_paiement',
                },
                {text: 'Type de la source', value: '_usermeanspaiement._means_paiement._type'},
                {text: 'Numéro du compte', value: '_usermeanspaiement._account_number'},
                {text: 'Montant', value: '_montant'},
                {text: 'Période', value: '_periode'},
                {text: 'Notification', value: '_send_mail'},
                {text: 'Dernier reversement', value: '_last_reversement_date'},
                {text: 'Date', value: '_created_at'},


              ],
                editedIndex: -1,
                editedItem: {
                    _type_transfert: '',
                    _montant: 1,
                    _periode: 'Mois',
                    _send_mail: '',
                    _marchand: '',
                    _usermeanspaiement: '',
                    _type_means: '',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                  _type_transfert: '',
                  _montant: 1,
                  _periode: 'Mois',
                  _send_mail: '',
                  _marchand: '',
                  _usermeanspaiement: '',
                  _type_means: '',
                  _id: 0,
                  _created_at: 0,
                },
                periodeRules: [
                    v => !!v || 'Période de reversement requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                type_transfertRules: [
                    v => !!v || 'Type de reversement requis',
                ]
                ,
                montantRules: [
                    v => !!v || 'Montant du reversement requis',
                ],
                usermeanspaiementRules: [
                    v => !!v || 'Moyen de paiement requis. Si vous n\'avez aucun moyen de paiement enregistré, cliquez sur le bouton ci-dessous pour en ajouter',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('reversements.newtext') : this.$t('reversements.update')
            }
            ,
            ...mapState('user_means_paiements/', ['user_means_paiements']),
            ...mapState('historiqueReversementsConfigs/', ['historiqueReversementsConfigs']),
           //recuperation du marchand avec la configuration de reversement
            ...mapState('marchands/', ['marchandInfo']),
            ...mapState('generalsettings/',['generals','generalmarchands']),
            ...mapState('devises/', ['devise']),

        }
        ,
        mounted() {
          this.initialize()
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {
              let data = new FormData();
              data.append("id", this.$store.getters.marchand._id);
              data.append("type", "Mobile");
              this.$store.dispatch('user_means_paiements/getUser_means_paiementsBytype', data).then(response => {
                window.console.log('user_means_paiements', response)
              });
              //recuperation de l'historique des configurations
              let data2 = new FormData();
              data2.append("id", this.$store.getters.marchand._id);
              this.$store.dispatch('historiqueReversementsConfigs/gethistoriqueReversementsConfigs', data2).then(response => {
                window.console.log('historiqueReversements', response)
              });
              this.$store.dispatch('marchands/getSettingReversmt', data2).then(response => {
                window.console.log('infomar', response)
              });
              this.$store.dispatch('generalsettings/getGeneralSettingMarchand',this.$store.getters.marchand._id).then(response => {
                console.log('getGeneralSetting',response)
                let data3 = new FormData();
                data3.append("id", response.generalsettings.ddc);
                this.$store.dispatch('devises/getById',data3).then(response => {
                  window.console.log('devises', response)
                  this.devisedatas = response.data.devise;
                });
              });
              this.$store.dispatch('generalsettings/getGeneralSettingForMarchand',data2).then(response => {
                console.log('getGeneralSettingAdmin',response)
                this.generaldatas = response.generalsettings;
              });

            },
            getBackColor(type){
                if (type== this.editedItem._type_means){
                    return "background-color: rgb(0 181 164 / 16%)!important;";
                } else {
                    return "";
                }
            },
            getBackColorRev(type){
                if (type== this.editedItem._type_transfert){
                    return "background-color: rgb(0 181 164 / 16%)!important;";
                } else {
                    return "";
                }
            },

            showDetail(){
              this.dialogDetail =  true;
            },
            shownote(vnote){
                this.note = vnote;
                this.dialogNote = true;
            },
            closeNote(){
                this.note = "Vide";
                 this.dialogNote = false;
            },
            setdefault(){
                this.e1 = 1;
                this.step1=false;
                this.step2=false;
                this.step3=false;
                $(".chooseAll").css("background-color", "");
                $(".chooseAllRev").css("background-color", "");
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                  this.dialog = true;
            },
            setdefaultClose(){
                this.e1 = 1;
                this.step1=false;
                this.step2=false;
                this.step3=false;
                $(".chooseAll").css("background-color", "");
                $(".chooseAllRev").css("background-color", "");
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
                this.dialog = false;
            },
            chooseItem(item) {
                this.step1 = false;
                this.editedItem._type_means = item;
               /* $(".chooseAll").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");*/
                this.validestep(1)
                this.changeType(item)

            },
            chooseItemRev(item) {
                this.step2 = false;
                this.editedItem._type_transfert = item;
                /*$(".chooseAllRev").css("background-color", "");
                $("#" + item).css("background-color", "#A1C4E8");*/
                this.validestep(2)

            },
            validestep(step){

                switch (step) {
                    case 1:

                        if (this.typesLists.includes(this.editedItem._type_means))
                        {
                            this.step1 = true;
                        }else{
                            this.step1 = false;
                        }
                        break;

                    case 2:
                        if (this.typesLists2.includes(this.editedItem._type_transfert))
                        {
                            this.step2 = true;
                        }else{
                            this.step2 = false;
                        }
                        break;


                    case 3:
                        this.errors_means = null;
                        this.errors_montant = null;
                        if (this.editedItem._type_transfert=="bystep")
                        {
                            if (!isNaN(this.editedItem._montant))
                            {
                                if (parseFloat(this.editedItem._montant)>=parseFloat(this.generaldatas.mminr))
                                {

                                  if (parseFloat(this.editedItem._montant)>parseFloat(this.generaldatas.mmaxr))
                                  {
                                    this.step3 = false;
                                    this.errors_montant = this.$t("reversements.errors_montant4")+" "+this.generaldatas.mmaxr+" "+this.devisedatas._code_alpha;

                                  }else{
                                    if(this.editedItem._usermeanspaiement!='')
                                    {
                                        this.step3 = true;
                                    }else{
                                        this.step3 = false;
                                        this.errors_means = this.$t("reversements.errors_means");
                                    }
                                  }
                                }else{
                                    this.step3 = false;
                                    this.errors_montant = this.$t("reversements.errors_montant2")+" "+this.generaldatas.mminr+" "+this.devisedatas._code_alpha;
                                }
                            }else{
                                this.errors_montant = this.$t("reversements.errors_montant");
                            }

                        }else{
                            if(this.editedItem._usermeanspaiement!='')
                            {
                                this.step3 = true;
                            }else{
                                this.step3 = false;
                                this.errors_means = this.$t("reversements.errors_means");
                            }
                        }

                        break;

                }

            },
            changeType(item) {
                console.log(item)
                let data = new FormData();
                data.append("id", this.$store.getters.marchand._id);
                data.append("type", item);
                this.$store
                    .dispatch('user_means_paiements/getUser_means_paiementsBytype', data)
                    .then(response => {
                        window.console.log('user_means_paiements', response)
                    });
            },
            cancelReverse(item) {
                console.log(item);
                let data = new FormData();
                data.append("id", item._id);
                if (item._cancel === false || item._cancel === null) {
                    data.append("cancel", true);
                    console.log("cancel : true");

                } else {
                    data.append("cancel", false);
                    console.log("cancel : false");

                }
                data.append("_user", this.$store.getters.auth._id);
                this.$store.dispatch('reversements/getUpdateCancel', data).then(response => {
                    window.console.log('reversements', response)
                });
            },
            editItem(item) {
                this.editedIndex = this.cities.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem._region_id = item._region_id._id;
                this.dialog = true;

                $("#regions option").each(function () {
                    // Add $(this).val() to your list
                    // console.log($(this).val());
                    if ($(this).val() == item._region_id._id) {
                        console.log($(this).val());
                        $(this).attr("selected", "selected");
                    }
                });
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                this.step3 = false;
                let data = new FormData();
                if (this.editedItem._type_transfert === "bystep") {
                    data.append("_montant", this.editedItem._montant);
                    data.append("_periode", "---");
                } else {
                    data.append("_montant", "---");
                    data.append("_periode", this.editedItem._periode);
                }
                if (this.editedItem._send_mail === "success") {
                    data.append("_send_mail", this.editedItem._send_mail);
                } else {
                    data.append("_send_mail", "refused");
                }
                data.append("_type_transfert", this.editedItem._type_transfert);
                data.append("_marchand", this.$store.getters.marchand._id);
                data.append("_usermeanspaiement", this.editedItem._usermeanspaiement);
                data.append("_devise", this.devisedatas._id);
                let mineroute = 'reversements/setReversement';
                this.$store.dispatch(mineroute, data).then((response) => {
                    this.submitting = false;
                      this.step3 = true;
                      this.showSnackDefault(response);
                    if (response.error) {
                        this.errors.operation = response.message;
                    } else {
                        this.close();
                      this.initialize();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
            ,
            getColor(calories) {
              if (calories == "Banque") return 'green'
              else if (calories == "Mobile") return 'orange'
              else return 'green'
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else return 'red'
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        },mounted(){
this.changeHeaderName(this.$t('menus.reversements_configs'))
        }
    }
</script>

<style scoped>
.btn-custom-add{
  /* padding: 2%; */
}
 .v-toolbar--flat{
  display: none!important;
}
</style>
